import {
    Button,
    CardActions,
    FormControlLabel,
    Grid,
    InputAdornment,
    MenuItem,
    Radio,
    RadioGroup,
    TextField,
    Typography,
} from "@mui/material";
import * as qs from "query-string";
import { Axios, AxiosError } from "axios";
import React, { useEffect, useState, Dispatch } from "react";
import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";
import { useDispatch, useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import moment from "moment";
import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

import { loggedIn, loggedOut } from "../actions/loggedIn";
import { clearUserProfiles } from "../actions/userProfiles";
import { clearUserRole } from "../actions/userRole";
import {
  adminRegister,
  checkUserPhoneNumberExist,
  getRequestDemo,
  register,
} from "../api";
import { firebaseAuth, firebaseConfirmationResult } from "../firebase";
import { AppState } from "../reducers";
import {
    StyledCircularProgress,
    StyledContainer,
    StyledLoginCard,
    StyledLoginForm,
} from "../StyledComponents";
import { Register, RegisterUsing } from "../types/Register";
import { Role, RoleType } from "../types/UserRole";
import { VerifyPhoneNumber } from "../types/VerifyPhoneNumber";
import AlertDialog from "../components/AlertDialog";
import SimpleSnackBar, { SnackBarProp } from "../components/SimpleSnackBar";
import ImportCSVDialog from "../components/ImportCSVDialog";
import { TermsAndConditionsDialog } from "../components/TermsAndConitionsDialog";
import { useNavigate } from "react-router-dom";

const enCountryName: { [key: string]: string } = en;

const StyledRegisterCard = styled(StyledLoginCard)`
    top: 0;
    margin-top: 10px;
`;

// interface DateofBirth {
//     year: number | null;
//     month: number | null;
//     day: number | null;
// }

export default function RegisterPage(props: { setTitle: Dispatch<React.SetStateAction<string>>, langButt: JSX.Element }) {
    const dispatch = useDispatch();

    const Navigate = useNavigate();
  
    const {t} = useTranslation();
    const userRole = useSelector<AppState, RoleType | null>(
      (state) => state.userRole
    );

    const genders = [
      {
          value: "M",
          label: t("gender.male"),
      },
      {
          value: "F",
          label: t("gender.female"),
      },
    ];

    const use_smartphone_level = [
      {
          value: "no_knowledge",
          label: t("use_smartphone_level.no_knowledge"),
      },
      {
          value: "newbie",
          label: t("use_smartphone_level.newbie"),
      },
      {
          value: "familiar",
          label: t("use_smartphone_level.familiar"),
      },
    ];

    const mahjong_level = [
      {
          value: "no_knowledge",
          label: t("mahjong_level.no_knowledge"),
      },
      {
          value: "newbie",
          label: t("mahjong_level.newbie"),
      },
      {
          value: "familiar",
          label: t("mahjong_level.familiar"),
      },
    ];

    const education_level = [
      { value: "no_education", label: t("education_level.no_education") },
      { value: "primary_school", label: t("education_level.primary_school") },
      { value: "secondary_school", label: t("education_level.secondary_school") },
      { value: "university", label: t("education_level.university") },
      { value: "above_university", label: t("education_level.above_university") },
    ];  
  
    const newRegisterInfo: Register =
    {
      register_using: "email",
      email: "",
      email_confirmation: "",
      password: "",
      password_confirmation: "",
      user_id: "-1",
      name: "",
      gender: "",
      avatar_url: "",
      year_of_birth: null,
      occupation: "",
      user_role: "trial_individual",
      is_dementia_mode: false,
      smsCode: ""
    };
  
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  
    const [registerInfo, setRegisterInfo] = useState<Register>(newRegisterInfo);
  
    // const [verifyPhoneNumberInfo, setVerifyPhoneNumberInfo] = useState<VerifyPhoneNumber>({
    //   phone_number: undefined,
    //   verification_code: undefined,
    // });
  
    const [confirmationResult, setConfirmationResult] = useState<firebaseConfirmationResult>();
  
    const [smsCodeSent, setSmsCodeSent] = useState<boolean>(false);
  
    useEffect(() => {
      props.setTitle("notShow");
      if (userRole === "admin") {
        setErrorSnackBar({
          ...errorSnackBar,
          message: "You are registering with admin account!",
          open: true,
        });
      }
      const qsObject = qs.parse(window.location.search);
      let code: string;
      if (qsObject.code !== undefined && qsObject.code !== null) {
        if (typeof qsObject.code === "string") {
          dispatch(loggedOut());
          dispatch(clearUserProfiles());
          dispatch(clearUserRole());
          code = qsObject.code;
          console.log(code);
          setIsSubmitting(true);
          getRequestDemo(code)
            .then((data) => {
              if (data !== null) {
                setIsRegistrationAllowed(true);
                setRegisterInfo({
                  ...registerInfo,
                  email: data.email,
                  email_confirmation: data.email,
                  name: data.name,
                  user_role: "trial_center",
                  code: code,
                  displayName: data.company_name,
                  referralCode: data.referralCode,
                  phone: data.contact_number,
                });
                if (data.created_user_at !== 0) {
                  setRegistrationNotAllowedMessage(t("register.success_text_success"));
                  setIsRegistrationAllowed(false);
                  setOpenRegisterNotAllowedDialog(true);
                }
              } else {
                setRegistrationNotAllowedMessage(t("register.error_text_code_error"));
                setIsRegistrationAllowed(false);
                setOpenRegisterNotAllowedDialog(true);
              }
            })
            .catch((err) => {
              setRegistrationNotAllowedMessage(t("register.error_text_code_error"));
              setIsRegistrationAllowed(false);
              setOpenRegisterNotAllowedDialog(true);
            })
            .finally(() => setIsSubmitting(false));
        }
      } else {
        if (userRole !== "admin") {
          // if (process.env.NODE_ENV === "production" && process.env.REACT_APP_ENVIRONMENT !== "test") {
          //   setRegistrationNotAllowedMessage("公開註冊尚未開放")
          //   setOpenRegisterNotAllowedDialog(true);
          // } else {
          firebaseAuth.signOut();
          setIsRegistrationAllowed(true);
  
          // }
        } else {
          setIsRegistrationAllowed(true);
        }
      }
    }, []);
  
    type InputError = {
      isError: boolean,
      reason: string | null
    }
  
    const [emailError, setEmailError] = useState<InputError>({ isError: false, reason: null });
    const [confirmEmailError, setConfirmEmailError] = useState<InputError>({ isError: false, reason: null });
    const [passwordError, setPasswordError] = useState<InputError>({ isError: false, reason: null });
    const [confirmPasswordError, setConfirmPasswordError] = useState<InputError>({ isError: false, reason: null });
    const [nameError, setNameError] = useState<InputError>({ isError: false, reason: null });
    // const [genderError, setGenderError] = useState<boolean>(false);
    // const [yearError, setYearError] = useState<boolean>(false);
    const [country, setCountry] = useState<string>("HK");
    const [phoneError, setPhoneError] = useState<InputError>({ isError: false, reason: null });
    const [centerNameError, setCenterNameError] = useState<InputError>({ isError: false, reason: null });
    const [smsCodeError, setSmsCodeError] = useState<InputError>({ isError: false, reason: null });
  
    const [
      openRegisterSuccessfullyDialog,
      setOpenRegisterSuccessfullyDialog,
    ] = useState<boolean>(false);
  
    const [
      openRegisterNotAllowedDialog,
      setOpenRegisterNotAllowedDialog,
    ] = useState<boolean>(false);
  
    const [isRegistrationAllowed, setIsRegistrationAllowed] = useState<boolean>(
      false
    );
    
    const [
      registrationNotAllowedMessage,
      setRegistrationNotAllowedMessage,
    ] = useState<string>("");
  
    const closeErrorSnackBar = () => {
      setErrorSnackBar({ ...errorSnackBar, open: false });
    };
  
    const [errorSnackBar, setErrorSnackBar] = useState<SnackBarProp>({
      open: false,
      onClose: closeErrorSnackBar,
      message: "",
    });
  
    const [importDialogOpen, setImportDialogOpen] = useState<boolean>(false);
  
    const [openTACDialog, setOpenTACDialog] = useState<boolean>(false);
  
    const toggleTACDialog = (open: boolean) => {
      setOpenTACDialog(open);
    }
  
    const onLoginButtonClick = async (event: React.MouseEvent) => {
      event.preventDefault();
      console.log(registerInfo);
      let hasError = false;
      if (registerInfo.email === "") {
        setEmailError({ isError: true, reason: t("error.please_enter") });
        hasError = true;
      }
      else if (registerInfo.register_using === "email" && !validateEmail(registerInfo.email)) {
        setEmailError({ isError: true, reason: t("error.email_format") });
        hasError = true;
      }
      else if (registerInfo.register_using === "phone_number" && !validatePhone(registerInfo.email)) {
        setEmailError({ isError: true, reason: t("register.error_text_phone_format_error") });
        hasError = true;
      }
      if (registerInfo.password === "") {
        setPasswordError({ isError: true, reason: t("error.please_enter") });
        hasError = true;
      }
      else if (!validatePassword(registerInfo.password)) {
        setPasswordError({ isError: true, reason: t("error.pw_format") });
        hasError = true;
      }
      if (smsCodeSent === true && registerInfo.smsCode === "") {
        setSmsCodeError({ isError: true, reason: t("register.error_text_empty_code") });
        hasError = true;
      }
      if (registerInfo.email_confirmation === "") {
        setConfirmEmailError({ isError: true, reason: t("error.please_enter") });
        hasError = true;
      }
      if (
        registerInfo.register_using === "email" &&
        registerInfo.password_confirmation === ""
      ) {
        setConfirmPasswordError({ isError: true, reason: t("error.please_enter")});
        hasError = true;
      }
      if (registerInfo.email !== registerInfo.email_confirmation) {
        setConfirmEmailError({ isError: true, reason: t(`register.error_text_confirm_${registerInfo.register_using === "email" ? "email" : "phone"}_not_equal` as unknown as TemplateStringsArray) });
        hasError = true;
      }
      if (
        registerInfo.register_using === "email" &&
        registerInfo.password !== registerInfo.password_confirmation
      ) {
        setConfirmPasswordError({ isError: true, reason: t("register.error_text_confirm_pw_not_equal") });
        hasError = true;
      }
      if (registerInfo.code === undefined && registerInfo.name === "") {
        setNameError({ isError: true, reason: t("error.please_enter") });
        hasError = true;
      }
      // if (registerInfo.code === undefined && registerInfo.register_using === "email" && registerInfo.phone === undefined) {
      //   setPhoneError(true);
      //   hasError = true;
      // }
      if (registerInfo.code === undefined && (registerInfo.user_role === 'center' || registerInfo.user_role === 'trial_center') && registerInfo.displayName === undefined) {
        setCenterNameError({ isError: true, reason: t("error.please_enter") });
        hasError = true;
      }
      // if (
      //   registerInfo.code === undefined &&
      //   registerInfo.year_of_birth === null
      // ) {
      //   setYearError(true);
      //   hasError = true;
      // }
      if (hasError) {
        setErrorSnackBar({ ...errorSnackBar, "open": true, message: t("error.multiply_empty") });
        return;
      }

      let _registerInfo = Object.assign({}, registerInfo);
      if (_registerInfo.register_using === "phone_number") {
        _registerInfo.email =
          "+" + getCountryCallingCode(country) + _registerInfo.email;
        _registerInfo.email_confirmation =
          "+" +
          getCountryCallingCode(country) +
          _registerInfo.email_confirmation;
      }
      setIsSubmitting(true);
      if (smsCodeSent) {
        if (_registerInfo.smsCode) {
          try {
            if (confirmationResult !== undefined) {
              const credential = await confirmationResult.confirm(
                _registerInfo.smsCode
              );
              if (checkIfPhoneLoginUserExist() === false) {
                try {
                  await _register(_registerInfo);
                } catch (e: any) {
                  console.log(e);
                  if (e.message) {
                    setErrorSnackBar({
                      ...errorSnackBar,
                      message: e.message,
                      open: true,
                    });
                  } else {
                    setErrorSnackBar({
                      ...errorSnackBar,
                      message: t("error.unknown"),
                      open: true,
                    });
                  }
                }
              } else {
                setErrorSnackBar({
                  ...errorSnackBar,
                  message: t("error.user_not_exist"),
                  open: true,
                });
              }
            }
          } catch (error: any) {
            //TODO: show error;
            console.log(error);
            let errorMessage = "";
            if (error.code === "auth/invalid-verification-code") {
              errorMessage = t("register.error_text_wrong_code");
            } else {
              errorMessage = error.message;
            }
            setErrorSnackBar({
              ...errorSnackBar,
              message: errorMessage,
              open: true,
            });
            console.log(error);
          }
          setIsSubmitting(false);
        }
      } else {
        if (_registerInfo.register_using === "phone_number") {
          const applicationVerifier = new RecaptchaVerifier(
            "recaptcha-container",
            { size: "invisible" },
            firebaseAuth
          );
          const phoneNumber = _registerInfo.email;
          const isExist = await checkUserPhoneNumberExist(phoneNumber);
          if (isExist) {
            setErrorSnackBar({
              ...errorSnackBar,
              message: t("register.error_text_registered_phone"),
              open: true,
            });
            setIsSubmitting(false);
            return;
          }

          // try {
          //   const confirmationResult = await 
          //   signInWithPhoneNumber(firebaseAuth, phoneNumber, applicationVerifier);
          //   setConfirmationResult(confirmationResult);
          //   setSmsCodeSent(true);
          //   setErrorSnackBar({
          //     ...errorSnackBar,
          //     message: "驗證碼已經送出，您將會在幾分鐘內收到。然後請在欄位輸入收到的驗證碼。",
          //     open: true,
          //   });
          // } catch (error: any) {
          //   let errorMessage = "";
          //   if (error.code === "auth/invalid-phone-number") {
          //     errorMessage = "The phone number format is not correct.";
          //   } else {
          //     errorMessage = error.message;
          //   }
          //   setErrorSnackBar({
          //     ...errorSnackBar,
          //     message: errorMessage,
          //     open: true,
          //   });
          //   console.log(error);
          // }
        } else {
          setIsSubmitting(true);
          if (userRole === "admin") {
            _registerInfo = { ..._registerInfo, emailVerified: true };
          }
          if (_registerInfo.user_role !== 'center' && _registerInfo.user_role !== 'trial_center') {
            _registerInfo = { ...registerInfo, displayName: _registerInfo.name };
          }
          try {
            await _register(_registerInfo);
          } catch (e: any) {
            let error = e as AxiosError;
            if (
              error.response &&
              error.response.data &&
              (error.response.data as any).message
            ) {
              setErrorSnackBar({
                ...errorSnackBar,
                message: e.response.data.message,
                open: true,
              });
            } else {
              setErrorSnackBar({
                ...errorSnackBar,
                message: e.message,
                open: true,
              });
            }
          }
        }
      }
      setIsSubmitting(false);
    };
  
    const _register = async (registerInfo: Register) => {
      try {
        if (userRole === "admin") {
          const valid = moment().add(14, "d").hour(23).minute(59).valueOf();
          await adminRegister({
            ...registerInfo,
            is_valid: true,
            valid_till: valid,
          });
          setOpenRegisterSuccessfullyDialog(true);
        } else {
          await register(registerInfo);
          setOpenRegisterSuccessfullyDialog(true);
        }
      } catch (e) {
        throw e;
      }
    };

    const checkIfPhoneLoginUserExist = () => {
      const user = firebaseAuth.currentUser;
      if (user !== null) {
        const metadata = user.metadata;
        console.log(metadata.creationTime);
        console.log(metadata.lastSignInTime);
        if (metadata.creationTime === metadata.lastSignInTime) {
          return false;
        } else {
          return true;
        }
      }
    };
  
    function validatePassword(pw: string) {
      const regex = /^.{6,}$/;
      return regex.test(pw);
    }
  
    const onRegisterFieldChange = (name: keyof Register, value: any) => {
      if (name === "email") {
        if (registerInfo.register_using === "email") {
          if (!validateEmail(value))
            setEmailError({ isError: true, reason: t("error.email_format") });
          else
            setEmailError({ isError: false, reason: null });
        }
        else {
          if (!validatePhone(value))
            setEmailError({ isError: true, reason: t("register.error_text_phone_format_error") });
          else
            setEmailError({ isError: false, reason: null });
        }
      }
  
      if (name === "email_confirmation") {
        if (registerInfo.register_using === "email") {
          if (value !== registerInfo.email)
            setConfirmEmailError({ isError: true, reason: t("register.error_text_confirm_email_not_equal") });
          else
            setConfirmEmailError({ isError: false, reason: null });
        }
        else {
          if (!validatePhone(value))
            setConfirmEmailError({ isError: true, reason: t("register.error_text_phone_format_error") });
          else if (value !== registerInfo.email)
            setConfirmEmailError({ isError: true, reason: t("register.error_text_confirm_phone_not_equal") });
          else
            setConfirmEmailError({ isError: false, reason: null });
        }
      }
  
      if (name === "password") {
        if (validatePassword(value)) {
          setPasswordError({ isError: false, reason: null });
        }
        else {
          setPasswordError({ isError: true, reason: t("error.pw_format") });
        }
      }
  
      if (name === "smsCode") {
        setSmsCodeError({ isError: false, reason: null });
      }
  
      if (name === "password_confirmation") {
        if (value !== registerInfo.password)
          setConfirmPasswordError({ isError: true, reason: t("register.error_text_confirm_pw_not_equal") });
        else
          setConfirmPasswordError({ isError: false, reason: null });
      }
      setNameError({ isError: false, reason: null });
      // setGenderError(false);
      // setYearError(false);
      setErrorSnackBar({ ...errorSnackBar, open: false });
      setRegisterInfo({ ...registerInfo, [name]: value });
    };
  
    const yearsSelect = (): Array<number> => {
      let years = [];
      for (
        let i = 1900;
        i < new Date().getFullYear() + 1;
        i++
      ) {
        years.push(i);
      }
      return years;
    };
  
    function validateEmail(email: string) {
      const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return regex.test(email.toLowerCase());
    }
  
    function validatePhone(phone: string) {
      const regex = /^[0-9]*$/;
      return regex.test(phone);
    }
  
    const closeRegisterSuccessfullyDialog = () => {
      setOpenRegisterSuccessfullyDialog(false);
      setRegisterInfo(newRegisterInfo);
      setIsRegistrationAllowed(false);
      returnHome()
    };

    const closeRegisterNotAllowedDialog = () => {
      setOpenRegisterNotAllowedDialog(false);
    };

    const handleregisterUsingChange = (
      event: React.ChangeEvent<HTMLInputElement>
    ) => {
      var registerUsing = (event.target as HTMLInputElement)
        .value as RegisterUsing;
      setRegisterInfo({
        ...registerInfo,
        register_using: registerUsing,
        email: "",
        email_confirmation: "",
        password: "",
        password_confirmation: "",
      });
    };
  
    const handleImportClick = () => {
      setImportDialogOpen(true);
    }
  
    const handleImportClose = () => {
      setImportDialogOpen(false);
    }

    const returnPlans = () => {
      Navigate("/plans")
    }

    const returnAccounts = () => {
      Navigate("/accounts")
    }

    const returnHome = () => {
      Navigate("/login")
    }
  
    return (
      <StyledContainer maxWidth="md">
        <SimpleSnackBar
          open={errorSnackBar.open}
          onClose={closeErrorSnackBar}
          message={errorSnackBar.message}
        />
        <AlertDialog
          open={openRegisterSuccessfullyDialog}
          onClose={closeRegisterSuccessfullyDialog}
          message={userRole === "center" || userRole === "trial_center" ? t("register.success_text_center") : (registerInfo.register_using === "phone_number" ? t("register.success_text_phone") : t("register.success_text_email"))}
        />
        <AlertDialog
          open={openRegisterNotAllowedDialog}
          onClose={closeRegisterNotAllowedDialog}
          message={registrationNotAllowedMessage}
        />
        <ImportCSVDialog open={importDialogOpen} onClose={handleImportClose} />
        <StyledRegisterCard>
          {isSubmitting && <StyledCircularProgress />}
          {registerInfo.code === undefined ? (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <div style={{ fontSize: 24, flex: userRole === 'admin' ? 1 : undefined }}>{userRole === "admin" ? t("register.quick_sign_up") : t("register.text_quick_sign_up")}</div>
              {userRole === 'admin' &&
                <Button
                  onClick={handleImportClick}
                  color="primary"
                  variant="outlined"
                >
                  {t("register.text_import_data")}
                </Button>
              }
              {userRole !== "admin" && (
                <Button
                  href="/centerregister"
                  variant="outlined"
                  color="primary"
                  style={{ fontSize: 24, marginLeft: 10 }}
                >
                  {t("register.text_sign_up_center")}
                </Button>
              )}
            </div>
          ) : (
            <div style={{ fontSize: 24 }}>{t("register.text_sign_up_center_done")}</div>
          )}
          <StyledLoginForm autoComplete="off">
            {registerInfo.code === undefined && (
              <RadioGroup
                aria-label="registerUsing"
                name="registerUsing"
                value={registerInfo.register_using}
                onChange={handleregisterUsingChange}
              >
                <FormControlLabel
                  value="email"
                  control={<Radio color='primary' />}
                  label={t("acc_key.email_address")}
                />
                <FormControlLabel
                  value="phone_number"
                  control={<Radio color='primary' />}
                  label={t("acc_key.phone_number")}
                  disabled={userRole === "admin" ? true : false}
                />
              </RadioGroup>
            )}

            {registerInfo.code === undefined && userRole === "admin" && (
              <TextField
                id="user_role"
                select
                label={t("common.role")}
                value={registerInfo.user_role? registerInfo.user_role : ""}
                onChange={e => onRegisterFieldChange("user_role", e.target.value)}
                margin="normal"
              >
                {Role.map((role) => (
                  <MenuItem key={role} value={role}>
                    {role}
                  </MenuItem>
                ))}
              </TextField>
            )}
  
            <Grid container spacing={1} alignItems="flex-end">
              {registerInfo.register_using === "phone_number" && (
                <Grid item xs={4}>
                  <TextField
                    id="countryCode"
                    select
                    label={t("common.country_code")}
                    value={country}
                    onChange={(event) => setCountry(event.target.value)}
                    margin="normal"
                    fullWidth
                  >
                    {getCountries().map((country: string) => (
                      <MenuItem key={country} value={country}>
                        {enCountryName[country]} +{getCountryCallingCode(country)}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
              )}
              <Grid
                item
                xs={registerInfo.register_using === "phone_number" ? 8 : 12}
              >
                <TextField
                  error={emailError.isError}
                  id="email"
                  required
                  label={
                    registerInfo.register_using === "email"
                      ? (t("acc_key.email_address"))
                      : (t("acc_key.phone_number"))
                  }
                  value={registerInfo.email}
                  onChange={e => onRegisterFieldChange("email", e.target.value)}
                  margin="normal"
                  InputProps={{
                    readOnly: registerInfo.code !== undefined ? true : false,
                  }}
                  fullWidth
                  helperText={emailError.isError && emailError.reason}
                />
              </Grid>
            </Grid>
            <TextField
              error={confirmEmailError.isError}
              id="email_confirmation"
              required
              label={
                t("butt.confirm") +
                (registerInfo.register_using === "email"
                  ? t("acc_key.email_address")
                  : t("acc_key.phone_number"))
              }
              value={registerInfo.email_confirmation}
              onChange={e => onRegisterFieldChange("email_confirmation", e.target.value)}
              margin="normal"
              InputProps={
                registerInfo.register_using === "phone_number"
                  ? {
                    startAdornment: (
                      <InputAdornment position="start">
                        {"+" + getCountryCallingCode(country)}
                      </InputAdornment>
                    ),
                  }
                  : {
                    readOnly: registerInfo.code !== undefined ? true : false,
                  }
              }
              helperText={confirmEmailError.isError && confirmEmailError.reason}
            />
  
            <TextField
              required
              error={passwordError.isError}
              id="password"
              label={t("acc_key.pw_format")}
              type="password"
              value={registerInfo.password? registerInfo.password : ""}
              onChange={e => onRegisterFieldChange("password", e.target.value)}
              margin="normal"
              helperText={passwordError.isError && passwordError.reason}
            />
  
            <TextField
              required
              error={confirmPasswordError.isError}
              id="password_confirmation"
              label={t("acc_key.pw_confirm")}
              type="password"
              value={registerInfo.password_confirmation? registerInfo.password_confirmation : ""}
              onChange={e => onRegisterFieldChange("password_confirmation", e.target.value)}
              margin="normal"
              helperText={confirmPasswordError.isError && confirmPasswordError.reason}
            />
  
            {(registerInfo.register_using === "phone_number") && smsCodeSent && (
              <TextField
                required
                error={smsCodeError.isError}
                label={t("register.text_label_code")}
                id="smsCode"
                value={registerInfo.smsCode? registerInfo.smsCode : ""}
                onChange={e => onRegisterFieldChange("smsCode", e.target.value)}
                margin="normal"
                helperText={smsCodeError.isError && smsCodeError.reason}
              />
  
            )}
  
            {registerInfo.code === undefined && (
              <TextField
                required
                error={nameError.isError}
                id="name"
                label={t("common.name")}
                value={registerInfo.name? registerInfo.name : ""}
                onChange={e => onRegisterFieldChange("name", e.target.value)}
                margin="normal"
                helperText={nameError.isError && nameError.reason}
              />
            )}
  
            {/* {registerInfo.register_using === "email" &&
              <TextField
                error={phoneError}
                id="phone"
                label={"聯絡電話 *"}
                value={registerInfo.phone}
                onChange={onRegisterFieldChange("phone")}
                margin="normal"
                fullWidth
              />} */}
  
            {registerInfo.code === undefined && (
              <TextField
                id="referralCode"
                label={t("common.referral_code_optional")}
                value={registerInfo.referralCode? registerInfo.referralCode : ""}
                onChange={e => onRegisterFieldChange("referralCode", e.target.value)}
                margin="normal"
              />
            )}
  
            {registerInfo.code === undefined && userRole === "admin" && (registerInfo.user_role === 'center' || registerInfo.user_role === 'trial_center') && (
              <TextField
                // error={genderError}
                id="gender"
                select
                label={t("common.gender")}
                value={registerInfo.gender? registerInfo.gender : ""}
                onChange={e => onRegisterFieldChange("gender", e.target.value)}
                margin="normal"
              >
                {genders.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            )}
  
            {registerInfo.code === undefined && userRole === "admin" && (registerInfo.user_role === 'center' || registerInfo.user_role === 'trial_center') && (
              <TextField
                // error={yearError}
                id="year"
                select
                label={t("common.year_of_birth")}
                value={registerInfo.year_of_birth? registerInfo.year_of_birth : ""}
                onChange={e => onRegisterFieldChange("year_of_birth", e.target.value)}
                margin="normal"
              >
                {yearsSelect().map((year) => (
                  <MenuItem key={year} value={year}>
                    {year}
                  </MenuItem>
                ))}
              </TextField>
            )}
  
            {registerInfo.code === undefined && userRole === "admin" && (registerInfo.user_role === 'center' || registerInfo.user_role === 'trial_center') && (
              <TextField
                id="occupation"
                label={t("common.occupation_previous_or_present")}
                value={registerInfo.occupation? registerInfo.occupation : ""}
                onChange={e => onRegisterFieldChange("occupation", e.target.value)}
                margin="normal"
                fullWidth
              />
            )}
  
            {registerInfo.code === undefined && userRole === "admin" && (registerInfo.user_role === 'center' || registerInfo.user_role === 'trial_center') && (
              <TextField
                id="use_smartphone_level"
                select
                label={t("common.use_smartphone_level")}
                value={registerInfo.use_smartphone_level? registerInfo.use_smartphone_level : ""}
                onChange={e => onRegisterFieldChange("use_smartphone_level", e.target.value)}
                margin="normal"
              >
                {use_smartphone_level.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            )}
  
            {registerInfo.code === undefined && userRole === "admin" && (registerInfo.user_role === 'center' || registerInfo.user_role === 'trial_center') && (
              <TextField
                id="education_level"
                select
                label={t("common.education_level")}
                value={registerInfo.education_level? registerInfo.education_level : ""}
                onChange={e => onRegisterFieldChange("education_level", e.target.value)}
                margin="normal"
              >
                {education_level.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            )}
  
            {registerInfo.code === undefined && userRole === "admin" && (registerInfo.user_role === 'center' || registerInfo.user_role === 'trial_center') && (
              <TextField
                id="mahjong_level"
                select
                label={t("common.mahjong_level")}
                value={registerInfo.mahjong_level? registerInfo.mahjong_level : ""}
                onChange={e => onRegisterFieldChange("mahjong_level", e.target.value)}
                margin="normal"
              >
                {mahjong_level.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            )}
  
            {registerInfo.code === undefined && userRole === "admin" &&
              (registerInfo.user_role === 'center' || registerInfo.user_role === 'trial_center') && (
                <>
                  <TextField
                    required
                    id="displayName"
                    error={centerNameError.isError}
                    label={t("register.text_label_display_name")}
                    value={registerInfo.displayName? registerInfo.displayName : ""}
                    onChange={e => onRegisterFieldChange("displayName", e.target.value)}
                    margin="normal"
                    fullWidth
                    helperText={centerNameError.isError && centerNameError.reason}
                  />
                  <TextField
                    id="quota"
                    label={t("register.quota")}
                    type="number"
                    value={registerInfo.quota? registerInfo.quota : ""}
                    onChange={e => onRegisterFieldChange("quota", e.target.value)}
                    margin="normal"
                    InputProps={{ inputProps: { min: 0 } }}
                  />
                </>
              )}
            <br /><br />
            <Typography style={{ fontWeight: "bold", fontSize: "18px" }}>
              {t("register.text_statment_1")}<a href="#" onClick={() => toggleTACDialog(true)}><i>{t("register.text_statment_2")}</i></a>{t("register.text_statment_3")}
            </Typography>
            <CardActions
              style={{ marginLeft: "auto" }}
            >
              <Button
                onClick={userRole === "admin" ? returnAccounts : returnPlans}
              >
                {t("butt.cancel")}
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                onClick={onLoginButtonClick}
                disabled={isSubmitting || !isRegistrationAllowed}
              >
                {t("butt.submit")}
              </Button>
            </CardActions>
          </StyledLoginForm>
        </StyledRegisterCard>
        <div id="recaptcha-container"></div>
        <TermsAndConditionsDialog open={openTACDialog} toggleDialog={toggleTACDialog} />
        {!userRole && props.langButt}
      </StyledContainer>
    );
}
  